import React, { useEffect, useMemo, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { ProductModel } from '../../models/product.model';
import cartApis from '../../apis/cart.api';
import { GLOBAL } from '../../constants/global.const';
import cartUtils from '../../utils/cart.utils';
import alertUtils, { SWAL } from '../../utils/alert.util';
import _ from 'lodash';
import globalUtils from '../../utils/global.util';

const CartDetail = () => {
    const [listProduct, setListProduct] = useState([]);
    const [listOrigin, setListOrigin] = useState([]);

    const totalPrice = useMemo(() => {
        if (listOrigin.length === 0) return '0';
        return globalUtils.formatNumberToPrice(_.sumBy(listOrigin, 'total'));
    }, [listOrigin]);

    const fetchData = async () => {
        try {
            const cartStorage = cartUtils.get();
            if (!cartStorage) {
                return;
            }
            const listItem = JSON.parse(cartStorage);
            if (listItem.length === 0) {
                return;
            }
            const { status, data } = await cartApis.getCartInfo(listItem);

            if (status !== 200) {
                return;
            }

            const listRes = data.data;

            let listView = [];

            listItem.forEach((item) => {
                const objCheck = listRes.find((o) => o.cp_id == item.id);
                if (objCheck != null) {
                    listView = [
                        new ProductModel({
                            ...objCheck,
                            quantity: item.quantity,
                        }),
                        ...listView,
                    ];
                }
            });

            setListProduct(listView);
            setListOrigin(listView);
        } catch (err) {
            console.log(err);
        }
    };

    window.addEventListener('storage', ({ key }) => {
        if (key === GLOBAL.CART_STORAGE) {
            fetchData();
        }
    });

    useEffect(() => {
        fetchData();
    }, []);

    const onChangeItem = (s, item) => {
        let { value } = s.target;
        if (value <= 0) {
            value = 1;
        }
        setListProduct((prevState) => {
            return prevState.map((o) => {
                if (o.cp_id === item.cp_id) {
                    o.quantity = value;
                }
                return new ProductModel(o);
            });
        });
    };

    const onRemoveItem = (item) => {
        const _list = listProduct.filter((o) => o.cp_id !== item.cp_id);
        const listStorage = _list.map((o) => {
            return {
                id: o.cp_id,
                quantity: o.quantity,
            };
        });
        cartUtils.set(listStorage);
        setListProduct(_list);
    };

    const onRemoveCart = async () => {
        const swalRes = await alertUtils.show(
            SWAL.TYPE.QUESTION,
            'Bạn muốn xóa hết sản phẩm trong giỏ hàng chứ ?',
            true
        );
        if (swalRes.isConfirmed) {
            cartUtils.set([]);
            setListProduct([]);
        }
    };

    const onUpdateCart = () => {
        try {
            const listStorage = listProduct.map((o) => {
                return {
                    id: o.cp_id,
                    quantity: o.quantity,
                };
            });
            cartUtils.set(listStorage);
            alertUtils.show(
                SWAL.TYPE.SUCCESS,
                'Bạn đã cập nhật giỏ hàng thành công'
            );
        } catch (err) {
            console.log(err);
        }
    };

    const showProduct = () => {
        if (listProduct.length === 0) return null;

        return listProduct.map((item, index) => {
            return (
                <tr className="item_cart" key={index}>
                    <td className="product-photo">
                        <img
                            src={`${GLOBAL.CDN_LINK}${item.cp_imageid}`}
                            alt={item.cp_name}
                        />
                    </td>
                    <td className="produc-name">
                        <a
                            href={`/chi-tiet-san-pham/${item.cp_seocode}`}
                            title=""
                        >
                            {item.cp_name}
                        </a>
                    </td>
                    <td className="produc-price">
                        <input
                            defaultValue={item.cp_unitpriceStr}
                            size="10"
                            type="text"
                        />
                    </td>
                    <td className="product-quantity">
                        <div className="product-signle-options product_15 clearfix">
                            <div className="selector-wrapper size">
                                <div className="quantity">
                                    <input
                                        value={item.quantity}
                                        title="Qty"
                                        className="qty"
                                        size="4"
                                        type="number"
                                        min={1}
                                        onChange={(s) => onChangeItem(s, item)}
                                    />
                                </div>
                            </div>
                        </div>
                    </td>
                    <td className="total-price">{item.totalStr}</td>
                    <td className="product-remove">
                        <a
                            className="remove"
                            title="close"
                            onClick={() => onRemoveItem(item)}
                        >
                            <img
                                src="/images/icon-delete-cart.png"
                                alt="close"
                            />
                        </a>
                    </td>
                </tr>
            );
        });
    };

    return (
        <>
            {listProduct.length > 0 ? (
                <div className="box cart-container">
                    <table className="table cart-table space-30">
                        <thead>
                            <tr>
                                <th className="product-photo">Sản phẩm</th>
                                <th className="produc-name"></th>
                                <th className="produc-price">Đơn giá</th>
                                <th className="product-quantity">Số lượng</th>
                                <th className="total-price">Thành tiền</th>
                                <th className="product-remove"></th>
                            </tr>
                        </thead>
                        <tbody>{showProduct()}</tbody>
                    </table>
                    <div className="box space-30">
                        <div className="float-left">
                            <a
                                className="link-v1 lh-50 margin-right-20 space-20"
                                title="CLEAR SHOPPING CART"
                                onClick={onRemoveCart}
                            >
                                XÓA GIỎ HÀNG
                            </a>
                            <a
                                className="link-v1 lh-50 space-20"
                                title="UPDATE SHOPPING CART"
                                onClick={onUpdateCart}
                            >
                                CẬP NHẬT GIỎ HÀNG
                            </a>
                        </div>

                        <div className="float-right">
                            <a
                                className="link-v1 lh-50 bg-brand"
                                href="/san-pham"
                                title="Tiếp tục mua hàng"
                            >
                                TIẾP TỤC MUA HÀNG
                            </a>
                        </div>
                    </div>

                    <div className="box cart-total space-30">
                        <div className="row">
                            <div className="col-md-4 space-30">
                                <div className="item coupon-code">
                                    <h3 className="title">MÃ GIẢM GIÁ</h3>
                                    <p>Nhập mã giảm giá của bạn</p>

                                    <div className="form-group">
                                        <input
                                            type="text"
                                            className="form-control space-20"
                                            id="coundpon"
                                        />
                                    </div>

                                    <a
                                        className="link-v1 lh-50 rt"
                                        href="#"
                                        title="apply coupon"
                                    >
                                        ÁP DỤNG
                                    </a>
                                </div>
                            </div>
                            <div className="col-md-4 space-30">
                                <div className="item">
                                    <h3 className="title">
                                        ƯỚC TÍNH PHÍ VẬN CHUYỂN
                                    </h3>
                                    <p>
                                        Nhập địa chỉ của bạn để nhận ước tính
                                        vận chuyển
                                    </p>

                                    <div className="form-group">
                                        <label
                                            className="control-label"
                                            htmlFor="inputcountry"
                                        >
                                            Tỉnh/Thành phố <span>*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control space-20"
                                            id="inputcountry"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label
                                            className="control-label"
                                            htmlFor="state"
                                        >
                                            Quận/Huyện <span>*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control space-20"
                                            id="state"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label
                                            className="control-label"
                                            htmlFor="zip-code"
                                        >
                                            Phường/Xã <span>*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control space-20"
                                            id="zip-code"
                                        />
                                    </div>

                                    <a
                                        className="link-v1 lh-50 rt"
                                        href="#"
                                        title="tính phí"
                                    >
                                        TÍNH PHÍ
                                    </a>
                                </div>
                            </div>

                            <div className="col-md-4 space-30">
                                <div className="item">
                                    <h3 className="title">TỔNG CỘNG</h3>
                                    <p className="box">
                                        <span className="float-left">
                                            <b>TẠM TÍNH</b>
                                        </span>
                                        <span className="float-right">
                                            <b className="color-brand">
                                                {totalPrice}
                                            </b>
                                        </span>
                                    </p>
                                    <p className="box">
                                        <span className="float-left">
                                            GIẢM GIÁ
                                        </span>
                                        <span className="float-right">0</span>
                                    </p>
                                    <p className="box">
                                        <span className="float-left">
                                            PHÍ GIAO HÀNG
                                        </span>
                                        <span className="float-right">0</span>
                                    </p>
                                    <p className="box space-30">
                                        <span className="float-left">
                                            <b>TỔNG TIỀN</b>
                                        </span>
                                        <span className="float-right">
                                            <b className="color-brand">
                                                {totalPrice}
                                            </b>
                                        </span>
                                    </p>
                                    <a
                                        className="link-v1 lh-50 rt"
                                        href="/thanh-toan"
                                        title="POCEEED TO CHECKOUT"
                                    >
                                        TIẾN HÀNH THANH TOÁN
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <p>Chưa có sản phẩm trong giỏ hàng</p>
            )}
        </>
    );
};

CartDetail.propTypes = {};

export default CartDetail;

document.querySelectorAll('react-cart-detail').forEach((domContainer) => {
    const root = createRoot(domContainer);

    root.render(<CartDetail />);
});
